import { render, staticRenderFns } from "./ForeignCurrencyLayby.vue?vue&type=template&id=2658f715&scoped=true"
import script from "./ForeignCurrencyLayby.vue?vue&type=script&lang=js"
export * from "./ForeignCurrencyLayby.vue?vue&type=script&lang=js"
import style0 from "./ForeignCurrencyLayby.vue?vue&type=style&index=0&id=2658f715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2658f715",
  null
  
)

export default component.exports